<template>
    <form-element :style="{
    margin: '0 auto',
  }">
        <h2 style="text-align:center">Wertung Abzug</h2>
        <div id="Wertung" style="text-align:center">
            <h1 class="wertungfont">{{ value }}</h1>
        </div>
        <fieldset>
            <legend>Pflichtstellungen</legend>
            <div id="Wertung" class="FScontainer">
                <div id="HakdariSeogi" class="FScontainer_left">
                    <div><h4>Hakdari Seogi fehlt&nbsp;&nbsp;-&nbsp;&nbsp;{{ valueHakdariSeogi }}</h4></div>
                    <k-switch :on-label="'I'" :off-label="'O'" @change="onChangeSwitchHakdariSeogi" :checked="checkedHakdariSeogi" />
                </div>
                &nbsp;&nbsp;
                <div id="BeomSeogi" class="FScontainer_center">
                    <div><h4>Beom Seogi fehlt&nbsp;&nbsp;-&nbsp;&nbsp;{{ valueBeomSeogi }}</h4></div>
                    <k-switch :on-label="'I'" :off-label="'O'" @change="onChangeSwitchBeomSeogi" :checked="checkedBeomSeogi" />
                </div>
                &nbsp;&nbsp;
                <div id="Dwitkubi" class="FScontainer_right">
                    <div><h4>Dwitkubi fehlt&nbsp;&nbsp;-&nbsp;&nbsp;{{ valueDwitkubi }}</h4></div>
                    <k-switch :on-label="'I'" :off-label="'O'" @change="onChangeSwitchDwitkubi" :checked="checkedDwitkubi" />
                </div>
            </div>
        </fieldset>
        <fieldset>
            <legend>Grenzenlinie</legend>
            <div id="Wertung" style="text-align:center">
                <div class="col-xs-12 col-sm-6 example-col">
                    <div><h4>Grenzlinie &uuml;berschritten&nbsp;&nbsp;-&nbsp;&nbsp;{{ valueGrenzlinie }}</h4></div>
                    <p>
                        <kbutton class="buttonKRWertungFSGrenzlinie" @click="handleGrenzliniePlus"><strong> + </strong></kbutton>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <kbutton class="buttonKRWertungFSGrenzlinie" @click="handleGrenzlinieMinus"><strong> - </strong></kbutton>
                    </p>
                </div>
            </div>
        </fieldset>
        <fieldset>
            <legend>Team -und Paar Abz&uuml;ge</legend>
            <div id="Wertung" class="FScontainer">
                <div id="Konfusion">
                    <div><h4>Konfusion&nbsp;&nbsp;-&nbsp;&nbsp;{{ valueKonfusion }}</h4></div>
                    <k-switch :on-label="'I'" :off-label="'O'" @change="onChangeSwitchKonfusion" :checked="checkedKonfusion" />
                </div>
                &nbsp;&nbsp;
                <div id="Synchronitaet">
                    <div><h4>Synchronit&auml;t&nbsp;&nbsp;-&nbsp;&nbsp;{{ valueSynchronitaet }}</h4></div>
                    <k-switch :on-label="'I'" :off-label="'O'" @change="onChangeSwitchSynchronitaet" :checked="checkedSynchronitaet" />
                </div>
                &nbsp;&nbsp;
                <div id="Handhilfe">
                    <div><h4>Handhilfe&nbsp;&nbsp;-&nbsp;&nbsp;{{ valueHandhilfe }}</h4></div>
                    <k-switch :on-label="'I'" :off-label="'O'" @change="onChangeSwitchHandhilfe" :checked="checkedHandhilfe" />
                </div>
            </div>
        </fieldset>
    </form-element>
</template>
<script>
    import { FormElement } from '@progress/kendo-vue-form';
    import { Switch } from "@progress/kendo-vue-inputs";
    import { Button } from '@progress/kendo-vue-buttons';

    import store from '@/store/store.js';

    export default {
        components: {
            'form-element': FormElement,
            "k-switch": Switch,
            kbutton: Button,
            store
        },
        data() {
            return {
                value: 0,
                valueHakdariSeogi: 0,
                valueBeomSeogi: 0,
                valueDwitkubi: 0,
                valueGrenzlinie: 0,
                valueKonfusion: 0,
                valueSynchronitaet: 0,
                valueHandhilfe: 0,
                checkedHakdariSeogi: false,
                checkedBeomSeogi: false,
                checkedDwitkubi: false,
                checkedKonfusion: false,
                checkedSynchronitaet: false,
                checkedHandhilfe: false
            };
        },
        props: {
            reset: Number,
        },
        watch: {
            reset() {
                console.log('Reset');
                this.value = 0;
                this.checkedHakdariSeogi = false;
                this.checkedBeomSeogi = false;
                this.checkedDwitkubi = false;
                this.checkedKonfusion = false;
                this.checkedSynchronitaet = false;
                this.checkedHandhilfe = false;
                this.kendoForm.onFormReset();
            },
        },
        mounted() {
            //Falls keine �nderung erfolgt!
            store.teilnehmer_Abzug = this.value;
        },
        methods: {
            onChangeSwitchHakdariSeogi(e) {
                this.checkedHakdariSeogi = e.target.value;
                if (this.checkedHakdariSeogi === true) {
                    this.valueHakdariSeogi = 0.3;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                } else {
                    this.valueHakdariSeogi = 0;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                }
                console.log("--------> TechnikAbzug:", this.valueHakdariSeogi)
            },
            onChangeSwitchBeomSeogi(e) {
                this.checkedBeomSeogi = e.target.value;
                if (this.checkedBeomSeogi === true) {
                    this.valueBeomSeogi = 0.3;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                } else {
                    this.valueBeomSeogi = 0;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                }
                console.log("--------> TechnikAbzug:", this.valueBeomSeogi)
            },
            onChangeSwitchDwitkubi(e) {
                this.checkedDwitkubi = e.target.value;
                if (this.checkedDwitkubi === true) {
                    this.valueDwitkubi = 0.3;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                } else {
                    this.valueDwitkubi = 0;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                }
                console.log("--------> TechnikAbzug:", this.valueDwitkubi)
            },
            onChangeSwitchKonfusion(e) {
                this.checkedKonfusion = e.target.value;
                if (this.checkedKonfusion === true) {
                    this.valueKonfusion = 0.3;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                } else {
                    this.valueKonfusion = 0;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                }
                console.log("--------> TechnikAbzug:", this.valueKonfusion)
            },
            onChangeSwitchSynchronitaet(e) {
                this.checkedSynchronitaet = e.target.value;
                if (this.checkedSynchronitaet === true) {
                    this.valueSynchronitaet = 0.3;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                } else {
                    this.valueSynchronitaet = 0;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                }
                console.log("--------> TechnikAbzug:", this.valueSynchronitaet)
            },
            onChangeSwitchHandhilfe(e) {
                this.checkedHandhilfe = e.target.value;
                if (this.checkedHandhilfe === true) {
                    this.valueHandhilfe = 0.3;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value, 1);
                    store.teilnehmer_Abzug = this.value;
                } else {
                    this.valueHandhilfe = 0;
                    this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet + this.valueHandhilfe;
                    this.value = this.round(this.value,1);
                    store.teilnehmer_Abzug = this.value;
                }
                console.log("--------> TechnikAbzug:", this.valueHandhilfe)
            },
            handleGrenzliniePlus(event) {
                console.log("--------> event:", event)
                this.valueGrenzlinie = this.round(this.valueGrenzlinie + 0.3,1) ;
                this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet;
                this.value = this.round(this.value,1);
                store.teilnehmer_Abzug = this.value;
            },
            handleGrenzlinieMinus(event) {
                console.log("--------> event:", event)
                const temp = this.round(this.valueGrenzlinie - 0.3,1);
                if (temp <= 0) {
                    this.valueGrenzlinie = 0;
                } else {
                    this.valueGrenzlinie = this.round(temp,1);
                }
                this.value = this.valueHakdariSeogi + this.valueBeomSeogi + this.valueDwitkubi + this.valueGrenzlinie + this.valueKonfusion + this.valueSynchronitaet;
                this.value = this.value.toFixed(1);
                store.teilnehmer_Abzug = this.value;
            },
            round(value, precision) {
                const multiplier = Math.pow(10, precision || 0); return Math.round(value * multiplier) / multiplier;
            }
        }
    };
</script>

